<template>
  <p class="text-[#B7B7B7] text-sm font-sans">
    <slot></slot>
  </p>
</template>

<script lang="ts" setup></script>
